import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=400e6b9c&"
import script from "./CompanyDashboard.vue?vue&type=script&lang=ts&"
export * from "./CompanyDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage} from 'quasar'
component.options.components = Object.assign({QPage}, component.options.components || {})
